import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable, throwError } from "rxjs";
import { AppConfig } from "../shared/models/appConfig.model";
import { catchError, map } from "rxjs/operators";

enum EndpointRoutes {
    GET_ALL_APP_CONFIGS = "configs/getAll",
    GET_APP_CONFIGS = "configs/get",
    UPDATE_APP_CONFIG = "configs/update",
    UPDATE_ALL_APP_CONFIGS = "configs/updateAll",
}

@Injectable({ providedIn: "root" })
export class AppConfigService {
    constructor(private _http: HttpClient) {}

    public getAll(): Observable<any[]> {
        return this._http.get<any[]>(environment.serverUrl + EndpointRoutes.GET_ALL_APP_CONFIGS).pipe(
            catchError((err) => {
                console.log(err);
                return throwError(() => err);
            }),
        );
    }

    public get(): Observable<AppConfig[]> {
        return this._http.get<AppConfig[]>(environment.serverUrl + EndpointRoutes.GET_APP_CONFIGS).pipe(
            map((res: any[]) => {
                res.forEach((r: any) => {
                    r.enabled = r.enabled.toString() === "1";
                });
                return res;
            }),
            catchError((err) => {
                console.log(err);
                return throwError(() => err);
            }),
        );
    }

    public update(config: AppConfig): Observable<any> {
        return this._http.post(environment.serverUrl + EndpointRoutes.UPDATE_APP_CONFIG, config).pipe(
            catchError((err) => {
                console.log(err);
                return throwError(() => err);
            }),
        );
    }

    updateAll(appConfigs: any[]) {
        return this._http.post(environment.serverUrl + EndpointRoutes.UPDATE_ALL_APP_CONFIGS, { appConfigs: appConfigs }).pipe(
            catchError((err) => {
                console.log(err);
                return throwError(() => err);
            }),
        );
    }
}
